import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { utils, ExtensionType, settings, extensions } from '@pixi/core';
import { LoaderParserPriority } from '@pixi/assets';
import { Spritesheet } from './Spritesheet.mjs';
var validImages = ["jpg", "png", "jpeg", "avif", "webp"];
function _getCacheableAssets(keys, asset, ignoreMultiPack) {
  var out = {};
  keys.forEach(function (key) {
    out[key] = asset;
  });
  Object.keys(asset.textures).forEach(function (key) {
    out[key] = asset.textures[key];
  });
  if (!ignoreMultiPack) {
    var basePath = utils.path.dirname(keys[0]);
    asset.linkedSheets.forEach(function (item, i) {
      var out2 = _getCacheableAssets(["".concat(basePath, "/").concat(asset.data.meta.related_multi_packs[i])], item, true);
      Object.assign(out, out2);
    });
  }
  return out;
}
var spritesheetAsset = {
  extension: ExtensionType.Asset,
  cache: {
    test: function test(asset) {
      return asset instanceof Spritesheet;
    },
    getCacheableAssets: function getCacheableAssets(keys, asset) {
      return _getCacheableAssets(keys, asset, false);
    }
  },
  resolver: {
    test: function test(value) {
      var tempURL = value.split("?")[0];
      var split = tempURL.split(".");
      var extension = split.pop();
      var format = split.pop();
      return extension === "json" && validImages.includes(format);
    },
    parse: function parse(value) {
      var _settings$RETINA_PREF, _settings$RETINA_PREF2;
      var split = value.split(".");
      return {
        resolution: parseFloat((_settings$RETINA_PREF = (_settings$RETINA_PREF2 = settings.RETINA_PREFIX.exec(value)) === null || _settings$RETINA_PREF2 === void 0 ? void 0 : _settings$RETINA_PREF2[1]) !== null && _settings$RETINA_PREF !== void 0 ? _settings$RETINA_PREF : "1"),
        format: split[split.length - 2],
        src: value
      };
    }
  },
  loader: {
    extension: {
      type: ExtensionType.LoadParser,
      priority: LoaderParserPriority.Normal
    },
    testParse: function testParse(asset, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", utils.path.extname(options.src).includes(".json") && !!asset.frames);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    parse: function parse(asset, options, loader) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _asset$meta;
        var basePath, imagePath, assets, texture, spritesheet, multiPacks, promises, _iterator, _step, _options$data, item, itemUrl, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              basePath = utils.path.dirname(options.src);
              if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) {
                basePath += "/";
              }
              imagePath = basePath + asset.meta.image;
              _context2.next = 5;
              return loader.load([imagePath]);
            case 5:
              assets = _context2.sent;
              texture = assets[imagePath];
              spritesheet = new Spritesheet(texture.baseTexture, asset, options.src);
              _context2.next = 10;
              return spritesheet.parse();
            case 10:
              multiPacks = asset === null || asset === void 0 ? void 0 : (_asset$meta = asset.meta) === null || _asset$meta === void 0 ? void 0 : _asset$meta.related_multi_packs;
              if (!Array.isArray(multiPacks)) {
                _context2.next = 39;
                break;
              }
              promises = [];
              _iterator = _createForOfIteratorHelper(multiPacks);
              _context2.prev = 14;
              _iterator.s();
            case 16:
              if ((_step = _iterator.n()).done) {
                _context2.next = 26;
                break;
              }
              item = _step.value;
              if (!(typeof item !== "string")) {
                _context2.next = 20;
                break;
              }
              return _context2.abrupt("continue", 24);
            case 20:
              itemUrl = basePath + item;
              if (!((_options$data = options.data) !== null && _options$data !== void 0 && _options$data.ignoreMultiPack)) {
                _context2.next = 23;
                break;
              }
              return _context2.abrupt("continue", 24);
            case 23:
              promises.push(loader.load({
                src: itemUrl,
                data: {
                  ignoreMultiPack: true
                }
              }));
            case 24:
              _context2.next = 16;
              break;
            case 26:
              _context2.next = 31;
              break;
            case 28:
              _context2.prev = 28;
              _context2.t0 = _context2["catch"](14);
              _iterator.e(_context2.t0);
            case 31:
              _context2.prev = 31;
              _iterator.f();
              return _context2.finish(31);
            case 34:
              _context2.next = 36;
              return Promise.all(promises);
            case 36:
              res = _context2.sent;
              spritesheet.linkedSheets = res;
              res.forEach(function (item) {
                item.linkedSheets = [spritesheet].concat(spritesheet.linkedSheets.filter(function (sp) {
                  return sp !== item;
                }));
              });
            case 39:
              return _context2.abrupt("return", spritesheet);
            case 40:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[14, 28, 31, 34]]);
      }))();
    },
    unload: function unload(spritesheet) {
      spritesheet.destroy(true);
    }
  }
};
extensions.add(spritesheetAsset);
export { spritesheetAsset };